// extracted by mini-css-extract-plugin
export default {"footermain":"Footer_footermain__rxlOQ"};